import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["progress_val", "inner_bars"];
  }
  initialize() {
    // console.log("Progress controller initialized");
  }
  connect() {
    // console.log("Progress controller in itialized");
    const progressValue = this.progress_valTarget;
    const value = Number(progressValue.innerText.substring(0, progressValue.innerText.length-1));

    const innerBarsWrapper = this.inner_barsTarget.children;

    function showBars(startIndex, endIndex) {
      for(let i = startIndex; i <= endIndex; i++) {
        innerBarsWrapper[i].classList.remove("hidden");
      }
    }

    if (value > 0 && value <= 10) {
      showBars(1,2)
    } else if (value > 10 && value <= 20) {
      showBars(1,4)
    } else if (value > 20 && value <= 30) {
      showBars(1,6)
    } else if (value > 30 && value <= 40) {
      showBars(1,8)
    } else if (value > 40 && value <= 50) {
      showBars(1,10)
    } else if (value > 50 && value <= 60) {
      showBars(1,12)
    } else if (value > 60 && value <= 70) {
      showBars(1,14)
    } else if (value > 70 && value <= 80) {
      showBars(1,16)
    } else if (value > 80 && value <= 90) {
      showBars(1,18)
    } else if (value > 90 && value <= 100) {
      showBars(1,20)
    }
  }
}
